import React, { Component } from 'react';
import { evaluate } from '@tencent/workbench';
import styles from './text.less.js';

class TextFormItem extends Component {
    constructor() {
        var _a;
        super(...arguments);
        this.value = (_a = this.props.defaultValue) !== null && _a !== void 0 ? _a : '';
    }
    render() {
        var _a;
        const value = evaluate(this.props.value, this.value);
        const options = evaluate(this.props.options, {});
        return React.createElement("div", { className: styles.text, style: { textAlign: (_a = options.align) !== null && _a !== void 0 ? _a : 'left' } }, value);
    }
}

export { TextFormItem };
//# sourceMappingURL=text.js.map
